import { Tag } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import { formatConversationStatus, getConversationStatusColor } from '~/helpers/conversation';

function TimeNotification({ conversation }) {
  const merchantLastMessageDate = dayjs(conversation.merchant_last_message_date);
  const showTimeNotification =
    conversation.response_needed_in || (conversation.merchant_last_message_date && merchantLastMessageDate.isBefore(dayjs().subtract(1, 'day')));
  return (
    <>
      {showTimeNotification && (
        <Tag
          className={`flex gap-xs items-center round caption1 small ${getConversationStatusColor(conversation).light && 'light'} ${!conversation.read_by_merchant && '!font-bold'}`}
          color={getConversationStatusColor(conversation).color}
        >
          {formatConversationStatus(conversation, merchantLastMessageDate)}
        </Tag>
      )}
    </>
  );
}

export default TimeNotification;
